(function() {
  function initSlideLinks() {
    var slides = document.querySelectorAll('.slideshow__slide');
    
    slides.forEach(function(slide) {
      var link = slide.querySelector('.bb-slide-link');
      if (!link) return;
      
      var href = link.getAttribute('href');
      if (!href) return;

      var startX = 0;
      var startY = 0;

      slide.addEventListener('mousedown', function(e) {
        startX = e.clientX;
        startY = e.clientY;
      });

      slide.addEventListener('mouseup', function(e) {
        var diffX = Math.abs(e.clientX - startX);
        var diffY = Math.abs(e.clientY - startY);
        if (diffX < 5 && diffY < 5) {
          window.location.href = href;
        }
      });

      slide.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      slide.addEventListener('touchend', function(e) {
        var diffX = Math.abs(e.changedTouches[0].clientX - startX);
        var diffY = Math.abs(e.changedTouches[0].clientY - startY);
        if (diffX < 10 && diffY < 10) {
          window.location.href = href;
        }
      });

      slide.style.cursor = 'pointer';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideLinks);
  } else {
    initSlideLinks();
  }
})();